import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { Location } from '../../../common/react/Location';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { MetricDefinition } from '../../../ts/models/ContentDefinitions';
import { Telemetry } from '../../../ts/services/TelemetryService';
import { MetricsSubspaceName } from '../../state/SpaceInfo';
import { ExplorerEmptyStateProps } from '../Components/ExplorerEmpyState';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { Subspace, TabbedSpace } from '../TabbedSpace';

export interface MetricsSpaceOwnProps extends ReactDirectiveProps{
  readonly telemetry: Telemetry;
  readonly activeSubspaceName: MetricsSubspaceName;
  readonly urls: SpacesSiteUrls;
}

export interface MetricsStateProps {}

export interface MetricsDispatchProps {}

export type MetricsProps = MetricsSpaceOwnProps & MetricsStateProps & MetricsDispatchProps;

export class MetricsSpace extends React.PureComponent<MetricsProps> {

  public constructor(props: MetricsProps){
    super(props);
  }

  public render() {

    const subspaces: ReadonlyArray<Subspace> = [
      this.createFavoritesSubspace(),
      this.createSubspace('all', Messages.all()),
      this.createSubspace('owned', Messages.ownedByMe())
    ];

    return <TabbedSpace
      subspaces={subspaces}
      activeSubspaceName={this.props.activeSubspaceName}
      urlForSubspace={(subspace: MetricsSubspaceName) => this.props.urls.exploreMetricsUrl(subspace) }
      mastheadElement={this.mastheadElement()}
      testIdPrefix={'metrics-tabbed-space'}
      spaceItemName={Messages.metrics()}
    />;
  }

  private createSubspace(name: MetricsSubspaceName, label: string): Subspace {
    return this.createSubspaceWithEmptyState(name, label, null);
  }

  private createSubspaceWithEmptyState(name: MetricsSubspaceName, label: string, emptyStateProps: ExplorerEmptyStateProps): Subspace {
    return {
      name,
      tabLabel: label,
      shouldRenderTabContentCount: false,
      renderContent: () => this.metricsExplorer(emptyStateProps),
    };
  }

  private createFavoritesSubspace() {
    return this.createSubspaceWithEmptyState('favorites', Messages.navigation_favorites(), {
      actionButtonMessage: Messages.emptyStateCallToAction(),
      primaryMessage: Messages.favoritesEmptyStatePrimary(),
      secondaryMessage: Messages.favoritesEmptyStateSecondary(),
      onActionButton: this.onEmptyFavoritesAction,
      iconUrl: imgPath('spaces_empty_favorite.svg'),
    });
  }

  private metricsExplorer(emptyStateProps?: ExplorerEmptyStateProps): JSX.Element {
    return <div className={ SpaceContainerStyles.SubplaceArea }>
      <ConnectedExplorer
        angularContext={this.props.angularContext}
        supportedDisplayModes={MetricDefinition.supportedDisplayModes}
        toolbarProps = {{
          toolbarVisibility: 'enabled',
          supportFilterPanel: true,
          hideSelection: false
        }}
        telemetry={this.props.telemetry}
        hideSelectionAndActionMenu={false}
        emptyStateProps={emptyStateProps}
      />
    </div>;
  }

  private mastheadElement(): React.ReactNode {
    return <div className={ ExplorerStyles.SpaceHeaderContent }>
      <div className={ ExplorerStyles.SpaceHeaderText }>{Messages.metrics()}</div>
    </div>;
  }

  private onEmptyFavoritesAction = (): void => {
    Location.instance.setUrl(this.props.urls.metricsAllUrl());
  }
}
